<template>
    <div class="learning-element-details" data-test-view="learning-element-details">
        <div v-show="element.description">
            <div class="element-description overflow-wrap">
                <l-text :text="element.description" />
            </div>
            <hr />
        </div>

        <l-learning-element :element="element" :option-select-disabled="true" />

        <br />

        <div class="footer">
            <button class="btn" data-test-id="learning-element-details-close" @click="closeModal">
                {{ $t("modal.close") }}
            </button>
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";

import LLearningElement from "@/components/LLearningElement";
import LText from "@/components/LText";

export default {
    components: {
        LLearningElement,
        LText,
    },
    props: {
        elementId: {
            type: String,
            default: "",
        },
    },
    computed: {
        ...mapGetters({
            getElement: "learning/library/element",
        }),
        element() {
            if (this.elementId) {
                return this.getElement(this.elementId);
            }

            return null;
        },
    },
    methods: {
        closeModal() {
            this.$router.push("/learning/library/archive");
        },
    },
};
</script>

<style scoped></style>
